var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "415px",
    height: "60px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(170, 0, 0)",
    d: "M14.375,0.000 L400.625,0.000 L370.000,46.000 L45.000,46.000 L14.375,0.000 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLine);
export default __webpack_public_path__ + "static/media/bar_line.dddc7aaf2c78af096ee94b70d9c1194a.svg";
export { ForwardRef as ReactComponent };